/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "0.1.0 nightly 2025-04-26",
    versionChannel: "nightly",
    buildDate: "2025-04-26T00:06:47.537Z",
    commitHash: "9c26f8541f265e064317a1f76206f9a0347ccb58",
};
